import { render, staticRenderFns } from "./PriceRanges.vue?vue&type=template&id=94eb4ba4"
import script from "./PriceRanges.vue?vue&type=script&lang=js"
export * from "./PriceRanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports